import { render, staticRenderFns } from "./VirtualResourceModifyPackage.vue?vue&type=template&id=2b258706&"
import script from "./VirtualResourceModifyPackage.vue?vue&type=script&lang=js&"
export * from "./VirtualResourceModifyPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports